import { courseHomeUrl, pageUrl } from "../../utils/urls";

import { t } from "i18n/i18n";
import { LegacyButton } from "mds/components/LegacyButton";
import { useQueryParamsManager } from "utils/routing";

const makeRedirectURL = (courseId: string, pageId: string) => {
  // For now, we just handle page redirects for LTI endpoint
  if (pageId) {
    return pageUrl(courseId, pageId);
  }
  return courseHomeUrl(courseId);
};

export default function Page() {
  const { getQueryParam } = useQueryParamsManager();
  const courseId = getQueryParam("courseId") || "";
  const pageId = getQueryParam("pageId") || "";
  const url = makeRedirectURL(courseId, pageId);

  return (
    <div className="m-5">
      <LegacyButton target="_blank" to={url}>
        {t("common.new_tab")}
      </LegacyButton>
    </div>
  );
}
